if (!Enum) {
    var Enum = {};
}

Enum.GUARDIAN_TYPE = {
    PARENT: 'PARENT',
    LEGAL_GUARDIAN: 'LEGAL_GUARDIAN',
    ACTUAL_GUARDIAN: 'ACTUAL_GUARDIAN',
    OTHER_THAN_PARENT_STATUORY_GUARDIAN: 'OTHER_THAN_PARENT_STATUORY_GUARDIAN'
};

Object.freeze(Enum.GUARDIAN_TYPE);